<template>
  <div class="pops-container">
    <slot>
    </slot>
  </div>
</template>

<script type="text/ecmascript-6">
  export default {
    mounted() {
    },
    methods: {
    },
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable.styl'
  .pops-container
    width: 100%
    height: 100%
    position: absolute
    background: $color-background
    top: 0
    left: 0
    z-index: 100
</style>



// WEBPACK FOOTER //
// rightPops.vue?20520be0